/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getFlagFollowersOverrides';

export type GetFlagFollowersPathParams = NonNullable<operations['getFlagFollowers']['parameters']['path']>;

export interface Input extends GetFlagFollowersPathParams {
  apiVersion?: string;
}

export async function getFlagFollowers(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/api/v2/projects/{projectKey}/flags/{featureFlagKey}/environments/{environmentKey}/followers',
    {
      params: { path },
      headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
      signal,
    },
  );
}
